import pathify from 'vuex-pathify'

// options
pathify.options.mapping = 'standard'
pathify.options.deep = true

export default pathify



// WEBPACK FOOTER //
// ./src/config/store.pathify.js